import React, { useState } from 'react';

// eslint-disable-next-line import/no-unresolved
import linkedinSVG from 'assets/resources/pages/about-us/linkedin_icon.svg';
import OnlyForSEO from '../../OnlyForSEO';
import ImgHTML from '../../ImgHTML';
import OptimizedImage from '../../OptimizedImage';

const TeamMember = ({ name, position, description, image }) => {
  const [activated, setActivated] = useState(false);
  const [mode, setMode] = useState(true);

  const myClass = activated ? 'hover' : '';
  const myText = mode ? 'See more' : 'Close';

  const readMoreHandler = () => {
    setActivated(!activated);
    setMode(!mode);
  };

  const classes = `about-me ${myClass}`;

  return (
    <div className="col-lg-4 col-md-6">
      <div className="member">
        <OptimizedImage
          src={image}
          alt={name}
          title={name}
          className="fluid-img"
        />
        <div className={classes}>
          <div className="forehead">
            <div className="nn">{name}</div>
            <div className="pp">{position}</div>
            <a href="https://www.linkedin.com/in/konradrotkiewicz/">
              <ImgHTML src={linkedinSVG} className="lin" alt="social icon" />
              <OnlyForSEO text="linkedin link" />
            </a>
          </div>
          <div
            onKeyDown={readMoreHandler}
            role="link"
            tabIndex={0}
            onClick={readMoreHandler}
            className="read-more wakeup"
          >
            {myText}
          </div>
          <div className="content">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default TeamMember;
